import { isObject } from "@helpers/utils.js";
import model from "@js/model.js";
import { nextTick } from "vue";

export default function(element, binding){
	let params = binding.value;
	if(!isObject(params)){
		params = {
			url: params,
		};
	}

	let oldParams = binding.oldValue;
	if(!isObject(oldParams)){
		oldParams = {
			url: oldParams,
		};
	}

	if(typeof params.updateAlways !== 'boolean') params.updateAlways = false;

	if(!params.updateAlways && params.url === oldParams.url) return;

	if(typeof params.onLoad === 'function') {
		element.removeEventListener('load', params.onLoad);
		element.addEventListener('load', params.onLoad);
	}

	nextTick(() => {
		params.iframeContainer = params.iframeContainer || binding.instance;
	
		var url = params.url;
		if(!url) url = 'about:blank';

		element.contentWindow.location.replace(url);
		params.iframeContainer['iframeElement'] = element;
		params.iframeContainer['contentWindow'] = element.contentWindow;
		
		let form = params.formPostData;
		if(form){
			element.contentWindow.document.body.appendChild(form);
			form.submit();
		}

		if(typeof params.iframeCreatedEventName === "string"){
			model.dispatchEvent(params.iframeCreatedEventName);
		}
	}, 0);
}